import { render, staticRenderFns } from "./resources-item.vue?vue&type=template&id=6df9a42f"
import script from "./resources-item.vue?vue&type=script&lang=js"
export * from "./resources-item.vue?vue&type=script&lang=js"
import style0 from "./resources-item.vue?vue&type=style&index=0&id=6df9a42f&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports